import { useNavigate } from '@tanstack/react-router';
import { useAddToWundo } from '@/lib/addToWundo.ts';
import { useLinkJourneySuggestion } from '@/lib/linkJourneySuggestion.ts';
import type { CalendarMeetingItem } from '@/lib/meetings.ts';

/**
 * The one click on a meeting. One Wundo is in opens; one it is not in is added,
 * on the journey step Wundo suggested if any, and the user stays on the week so
 * several can be added in one sweep. The page has one toast: the last action speaks.
 */
export function useAgendaSelect(userId: string | undefined) {
  const navigate = useNavigate();
  const addToWundo = useAddToWundo(userId);
  const linkSuggestion = useLinkJourneySuggestion(userId);

  const linkToSuggestedStep = (meeting: CalendarMeetingItem) => {
    addToWundo.dismiss();
    linkSuggestion.link(meeting);
  };

  const select = (meeting: CalendarMeetingItem) => {
    if (meeting.tracked) {
      void navigate({ to: '/meetings/$meetingId', params: { meetingId: meeting.id } });
      return;
    }
    if (meeting.journey_suggestion) {
      linkToSuggestedStep(meeting);
      return;
    }
    linkSuggestion.dismiss();
    addToWundo.add(meeting);
  };

  return {
    select,
    linkToSuggestedStep,
    toast: linkSuggestion.message !== null ? linkSuggestion : addToWundo,
  };
}
